import PropTypes from 'prop-types';

const NotesPropTypes = {
  actionBarItemClicked: PropTypes.shape({
    buttonId: PropTypes.string,
    dropdownItemId: PropTypes.string,
  }),
  info: PropTypes.shape({
    id: PropTypes.string,
    unreadNotesCount: PropTypes.number,
  }).isRequired,
  notes: PropTypes.shape({
    requesting: PropTypes.bool.isRequired,
    error: PropTypes.object,
    data: PropTypes.arrayOf(
      PropTypes.object,
    ).isRequired,
  }).isRequired,
  availableRecipients: PropTypes.shape({
    requesting: PropTypes.bool.isRequired,
    error: PropTypes.object,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        group: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
        user: PropTypes.shape({
          id: PropTypes.string.isRequired,
        }),
      }),
    ).isRequired,
  }).isRequired,
  clearAvailableRecipients: PropTypes.func.isRequired,
  loadNotes: PropTypes.func.isRequired,
  loadAvailableRecipients: PropTypes.func.isRequired,
  postNote: PropTypes.func.isRequired,
  setNotes: PropTypes.func.isRequired,
  updateNote: PropTypes.func.isRequired,
  scrollToUnreadNote: PropTypes.bool,
  updateScrollToUnreadNote: PropTypes.func.isRequired,
};

export default NotesPropTypes;



// WEBPACK FOOTER //
// ./compositions/NotesWidget/PropTypes.js